export default __webpack_public_path__ + "static/media/logo_without_border_design.045a20b5.png";